import { Grid } from '@mui/material';
import GenericParentDropdown from 'Components/FormControls/GenericParentDropdown';

const FieldDropdownGroup = ({ configList, onAction, onShuffle }) => {
  return configList.map(
    ({
      name,
      title,
      options,
      parentOptions,
      selectedParent,
      selectedGrandParent,
      extraDropdownOptions,
      currentLevel,
      isEditable
    }) => (
      <Grid item xs={12} sm={4} key={name}>
        <GenericParentDropdown
          name={name}
          title={title}
          options={options}
          parentOptions={parentOptions}
          selectedParent={selectedParent}
          selectedGrandParent={selectedGrandParent}
          extraDropdownOptions={extraDropdownOptions}
          currentLevel={currentLevel}
          isEditable={isEditable}
          onCreateOrUpdate={(...args) => onAction(...args)}
          onDelete={(...args) => onAction(...args)}
          onShuffle={(...args) => onShuffle(...args)}
        />
      </Grid>
    )
  );
};

export default FieldDropdownGroup;
